module.exports = __webpack_public_path__ + "static/media/smallBerryRight.37fb7e3c.svg";